// IMPORTANT: Load partner protection FIRST before anything else

import './styles/nomad/tokens.css';
import './styles/nomad/base.css';
import './styles/nomad/ui.css';
import './styles/nomad/shell.css';
import './styles/reset.css';
import 'leaflet/dist/leaflet.css';
import 'react-quill-new/dist/quill.snow.css';
import './index.css';
/* Generated styles/tokens.css is no longer the skin source — Nomad tokens.css is.
   applyCssVariables still updates brand vars on :root at runtime. */
import './utils/partnerProtection.js';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import App from './App.jsx';
import i18n from './app/shared/i18/i18n';
import { EntrepriseSettingsProvider } from './context/EntrepriseSettingsContext.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <EntrepriseSettingsProvider>
        <App />
      </EntrepriseSettingsProvider>
    </I18nextProvider>
  </StrictMode>,
)
